var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from 'react';
import { useValueControl } from '@snack-uikit/utils';
export const SelectionContext = createContext({
    value: undefined,
    onChange: undefined,
    mode: undefined,
});
export function isSelectionMultipleProps(props) {
    return 'mode' in props && props['mode'] === 'multiple';
}
export function isSelectionSingleProps(props) {
    return 'mode' in props && props['mode'] === 'single';
}
function SelectionNoneProvider({ children }) {
    return (_jsx(SelectionContext.Provider, { value: {
            mode: 'none',
        }, children: children }));
}
function SelectionSingleProvider({ value: valueProp, defaultValue, onChange: onChangeProp, children, }) {
    const [value, setValue] = useValueControl({
        value: valueProp,
        defaultValue,
        onChange: onChangeProp,
    });
    const onChange = useCallback((newValue) => setValue((oldValue) => {
        if (newValue !== oldValue) {
            return newValue;
        }
        return undefined;
    }), [setValue]);
    return (_jsx(SelectionContext.Provider, { value: {
            value,
            onChange,
            mode: 'single',
            isSelectionSingle: true,
            isSelectionMultiple: false,
            setValue,
        }, children: children }));
}
function SelectionMultipleProvider({ value: valueProp, defaultValue, onChange: onChangeProp, children, }) {
    const [value, setValue] = useValueControl({
        value: valueProp,
        defaultValue,
        onChange: onChangeProp,
    });
    const onChange = useCallback((newValue) => {
        setValue((oldValues) => {
            if (Array.isArray(oldValues)) {
                if (oldValues.includes(newValue)) {
                    return oldValues.filter(oldValue => oldValue !== newValue);
                }
                return oldValues.concat(newValue);
            }
            if (oldValues === undefined) {
                return Array.isArray(newValue) ? newValue : [newValue];
            }
            return undefined;
        });
    }, [setValue]);
    return (_jsx(SelectionContext.Provider, { value: {
            value,
            onChange,
            mode: 'multiple',
            isSelectionSingle: false,
            isSelectionMultiple: true,
            setValue,
        }, children: children }));
}
export function SelectionProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    if (isSelectionSingleProps(props)) {
        return _jsx(SelectionSingleProvider, Object.assign({}, props, { children: children }));
    }
    if (isSelectionMultipleProps(props)) {
        return _jsx(SelectionMultipleProvider, Object.assign({}, props, { children: children }));
    }
    return _jsx(SelectionNoneProvider, { children: children });
}
export function useSelectionContext() {
    return useContext(SelectionContext);
}
